export const SET_STATE = "SET_STATE";
export const START_TIMER = "START_TIMER";
export const STOP_TIMER = "STOP_TIMER";

export function setState(timer_state) {
	return {
		type: SET_STATE,
		timer_state,
	};
}

export function startTimer({ timer_duration }) {
	return {
		type: START_TIMER,
		timer_duration,
	};
}

export function stopTimer() {
	return {
		type: STOP_TIMER,
	};
}



// WEBPACK FOOTER //
// ../shared/store/timer/actions.js